import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink],
  template: `
    <footer class="footer">
      <div class="footer__glow"></div>

      <div class="container footer__inner">
        <div class="footer__left">
          <div class="brand">
            <span class="brand__mark"><img src="assets/data-bi-logo.svg" alt="Data BI" /></span>
            <span class="brand__name">Data BI <span class="accent">Solutions</span></span>
          </div>

          <p class="muted2 footer__intro">Des données fiables. Des décisions rapides. Nous concevons des solutions Data, BI et IA claires, performantes et prêtes à l'échelle.</p>

          <div class="footer__meta">
            <a class="footer__pill" href="mailto:contact@databi.solutions">contact&#64;databi.solutions</a>
            <span class="footer__pill">Data Engineering · BI · IA</span>
            <span class="footer__pill">France · Europe</span>
          </div>
        </div>

        <div class="footer__right">
          <div class="footer__panel">
            <div class="footer__eyebrow">Navigation</div>
            <div class="footer__links">
              <a routerLink="/">Accueil</a>
              <a routerLink="/about">À propos</a>
              <a routerLink="/services">Services</a>
              <a routerLink="/blog">Blog</a>
              <a routerLink="/careers">Carrières</a>
              <a routerLink="/contact">Contact</a>
            </div>
          </div>

          <div class="footer__panel footer__panel--cta">
            <div class="footer__eyebrow">Parlons de votre projet</div>
            <p class="muted2 footer__cta-copy">Audit, dashboard, pipeline ou automatisation&nbsp;: nous vous aidons à passer vite de l'idée à l'impact.</p>
            <a class="footer__cta" routerLink="/contact">Demander un échange</a>
          </div>
        </div>
      </div>

      <div class="footer__bottom">
        <div class="container footer__bottom-inner">
          <span>© {{ currentYear }} Data BI Solutions. Tous droits réservés.</span>
          <span class="made-by">Crafted by <strong>Datara Stack Works</strong></span>
        </div>
      </div>
    </footer>`,
  styles: [`
    .footer{
      position: relative;
      padding: 32px 0 20px;
      border-top: 1px solid rgba(255,255,255,.08);
      background: linear-gradient(180deg, rgba(7,11,23,.34), rgba(7,11,23,.64));
      overflow: clip;
    }

    .footer__glow{
      position:absolute;
      inset: 0 auto auto 50%;
      width: 420px;
      height: 180px;
      transform: translateX(-50%);
      background: radial-gradient(circle, rgba(79,125,255,.22), transparent 68%);
      pointer-events:none;
      filter: blur(12px);
      opacity:.9;
    }

    .footer__inner{
      position:relative;
      display:grid;
      grid-template-columns: minmax(0,1.2fr) minmax(0,.95fr);
      gap: 26px;
      align-items:start;
    }

    .footer__left{ min-width:0; }

    .brand{
      display:flex;
      align-items:center;
      gap:12px;
      font-weight:900;
      margin-bottom: 14px;
    }

    .brand__mark{
      width:56px;
      height:56px;
      flex:0 0 56px;
      display:flex;
      align-items:center;
      justify-content:center;
      border-radius:16px;
      box-shadow: 0 14px 45px rgba(0,0,0,.25);
      overflow:hidden;
    }

    .brand__mark img{
      width:100%;
      height:100%;
      object-fit:contain;
      display:block;
      filter: drop-shadow(0 12px 28px rgba(0,0,0,.35));
    }

    .brand__name{ font-size: 1.05rem; }
    .accent{ color: rgba(0,229,168,.95); }

    .footer__intro{
      max-width: 56ch;
      margin: 0 0 18px;
      line-height: 1.7;
    }

    .footer__meta{
      display:flex;
      flex-wrap:wrap;
      gap:10px;
    }

    .footer__pill{
      display:inline-flex;
      align-items:center;
      min-height: 38px;
      padding: 9px 14px;
      border-radius: 999px;
      border: 1px solid rgba(255,255,255,.10);
      background: rgba(255,255,255,.05);
      color: rgba(235,240,255,.84);
      font-weight: 700;
      font-size: 13px;
      box-shadow: 0 14px 35px rgba(0,0,0,.14);
    }

    .footer__right{
      display:grid;
      gap:14px;
    }

    .footer__panel{
      padding: 18px;
      border-radius: 24px;
      border: 1px solid rgba(255,255,255,.10);
      background: rgba(255,255,255,.04);
      box-shadow: 0 18px 50px rgba(0,0,0,.16);
    }

    .footer__eyebrow{
      font-size: 11px;
      letter-spacing: .14em;
      text-transform: uppercase;
      font-weight: 900;
      color: rgba(235,240,255,.54);
      margin-bottom: 12px;
    }

    .footer__links{
      display:flex;
      gap:10px;
      flex-wrap:wrap;
    }

    .footer__links a{
      color: rgba(235,240,255,.76);
      font-weight: 800;
      font-size: 13px;
      padding: 10px 12px;
      border-radius: 12px;
      background: rgba(255,255,255,.04);
      border: 1px solid rgba(255,255,255,.08);
    }

    .footer__links a:hover,
    .footer__pill:hover{
      color:#fff;
    }

    .footer__cta-copy{
      margin: 0 0 14px;
      line-height: 1.65;
    }

    .footer__cta{
      display:inline-flex;
      align-items:center;
      justify-content:center;
      min-height: 44px;
      padding: 0 16px;
      border-radius: 14px;
      font-weight: 900;
      color: #061024;
      background: linear-gradient(135deg, rgba(79,125,255,.95), rgba(0,229,168,.88));
      box-shadow: 0 16px 40px rgba(79,125,255,.24);
    }

    .footer__bottom{
      margin-top: 20px;
      padding-top: 16px;
      border-top: 1px solid rgba(255,255,255,.08);
    }

    .footer__bottom-inner{
      display:flex;
      justify-content:space-between;
      gap:12px;
      flex-wrap:wrap;
      color: rgba(235,240,255,.60);
      font-size: 13px;
    }

    @media (max-width: 860px){
      .footer{ padding-top: 26px; }
      .footer__inner{ grid-template-columns: 1fr; }
      .brand__mark{ width:48px; height:48px; }
    }
  `]
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
}
